import { Icon } from "@pepperstone/pepper-ui-kit";

import { Typo } from "../../Typo";
import { OverviewError } from "../types";

export const OverviewErrorBanner = ({
  error,
  message,
  isBackoffice = false,
  isMobile = false,
}: {
  error?: string;
  message: string;
  isBackoffice?: boolean;
  isMobile?: boolean;
}) => {
  if (!error?.includes(OverviewError.ConvertRateError)) return <></>;

  const topDesktop = isBackoffice ? "lg:top-[69px]" : "lg:top-[88px]";
  const topMobile = isBackoffice ? "top-[69px]" : "top-[64px]";
  const maxWidth = isBackoffice ? "max-w-[1280px]" : "max-w-[1518px]";
  const position = `${topDesktop} ${topMobile}`;
  const bannerLayer = `fixed ${position} ${
    isMobile ? "left-0 right-0 z-10 bg-surface-accent-amber-subtler" : "z-20"
  }`;

  return (
    <div className="h-12">
      {!isMobile && (
        <div
          className={`fixed left-0 right-0 z-10 h-12 bg-surface-accent-amber-subtler ${position}`}
        />
      )}
      <div className={bannerLayer}>
        <div
          className={`m-auto flex items-center gap-2 px-4 py-3 font-sans text-text-warning-bold ${maxWidth}`}
        >
          <Icon icon="alert-circle" size={16} />
          <Typo element="p" type="labelSM" textColor="text-text-warning-bold">
            {message}
          </Typo>
        </div>
      </div>
    </div>
  );
};
